import { Fragment, useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { formatCommentTime } from '~utils/common.utils';
import { mediumGap, primaryColor, textGrey } from '~theme';
import { Spacing } from '~ui-kit';

import CommentField from './CommentField';

const Comments = ({ comments, commentable, taskId }) => {
  const [open, setOpen] = useState(true);

  return commentable || comments.length ? (
    <Wrapper>
      <Container open={open} onClick={() => setOpen(!open)}>
        {comments.length ? (
          <Header clickable>
            <Arrow icon={!open ? faChevronDown : faChevronUp} />
            Kommentit ({comments.length})
          </Header>
        ) : (
          <Header>Ei kommentteja</Header>
        )}
      </Container>
      {comments.length && open ? (
        <>
          {comments.map(comment => (
            <Fragment key={comment.id}>
              <Spacing medium />
              <Author>
                {comment.initiator?.name},{' '}
                {formatCommentTime(comment.initiationTime)}
              </Author>
              <Spacing small />

              <Text>{comment.comment}</Text>
            </Fragment>
          ))}
        </>
      ) : null}
      <>
        <Spacing medium />
        <CommentField orderId={taskId} />
      </>
    </Wrapper>
  ) : null;
};

const Arrow = styled(FontAwesomeIcon)`
  width: 16px;
  margin-right: 12px;
`;

const Wrapper = styled.div`
  background-color: #f2f2f2;
  border-radius: 4px;
  padding: ${mediumGap};
`;

const Container = styled.div``;

const Header = styled.h2`
  margin: unset;
  font-weight: 400;
  font-size: 16px;
  color: ${primaryColor};

  cursor: ${props => (props.clickable ? 'pointer' : 'initial')};
`;

const Author = styled.h3`
  margin: unset;
  font-weight: bold;
  font-size: 12px;
  color: ${textGrey};
`;

const Text = styled.div`
  color: ${textGrey};
  font-size: 16px;
  font-weight: 400;
`;

export default Comments;
